import { useAuthStore } from '~/stores/auth.store';
import {
  type AccountModals,
  AccountModalsStrings,
  type Modals,
  siteModalsStrings,
} from '~/interfaces/dto/general/modals';
import { useNativeMessageHandler } from '~/composables/usePostMessage';
import { cleanJsonString } from '~/utilities/data-transformers';

interface IMessageHandler {
  action: string;
  actionValue: string;
  optinName?: string;
  platform?: string;
}

export default function (
  request: IMessageHandler,
  query?: Record<string, string>,
) {
  const { action, actionValue, optinName, platform } = request;
  const cleanedActionValue = cleanJsonString(actionValue);
  const router = useRouter();
  const route = useRoute();
  const authStore = useAuthStore();
  const siteStore = useSiteStore();
  const gameStore = useGameStore();
  const { $marketingService } = useServices();

  if (siteStore.isWebview) {
    useNativeMessageHandler({
      message: 'MessageHandler',
      data: { Value: cleanedActionValue, Action: action },
    });
    return;
  }

  switch (action.toUpperCase()) {
    case 'NAVIGATETO':
    case 'LAUNCHGAME': {
      if (route.path !== cleanedActionValue) gameStore.clearCompleteState();
      const qs = cleanedActionValue.split('?');
      query = !!query ? query : {};
      Object.assign(
        query,
        !!qs?.[1]
          ? qs?.[1]?.split('&').reduce((qa, q) => {
              const [k, v] = q.split('=');
              return { ...qa, [k]: v };
            }, {})
          : {},
      );

      return navigateTo({
        path: actionValue,
        ...(!!query && { query }),
      });
    }
    case 'NAVIGATENEWTAB':
      window.open(cleanedActionValue);
      break;
    case 'LAUNCH':
      const detail = () => {
        if (
          cleanedActionValue.toLowerCase() === 'registration' ||
          cleanedActionValue.toLowerCase() === 'register'
        )
          return '?register=1';

        return cleanedActionValue;
      };

      const refinedAction = detail()
        .replace(/[^a-zA-Z-]/g, '')
        .toLowerCase();
      if (
        AccountModalsStrings.includes(refinedAction as Partial<AccountModals>)
      ) {
        authStore.setAccountModalPage(refinedAction as Partial<AccountModals>);
        break;
      }
      if (siteModalsStrings.includes(refinedAction as Partial<Modals>)) {
        siteStore.activateModal(refinedAction);
        break;
      }

      router.push(detail());
      break;
    case 'ACCOUNT':
      authStore.toggleAccountModal(true);
      break;
    case 'OPTIN':
      $marketingService.setMarketingOptIn({
        vendorAccountID: authStore.user_id,
        optinName: optinName,
        source: platform,
        countryCode: siteStore.getRegionCode,
      });
      break;
    default:
      break;
  }
}
